import { useState } from "react";
import { Alert, Grid, Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Hook y Componentes de UI
import { useDeliveries } from "../hooks/useDeliveries";
import CustomTableNew from "../components/CustomTableNew.jsx";
import DeliveryChips from "../components/DeliveryChips.jsx";
import DeliveryActions from "../components/DeliveryActions.jsx";
import DeliveryFilters from "../components/DeliveryFilters.jsx";

function DeliveriesResume(props) {
  const {
    filters,
    pagination,
    tableSort,
    pageData,
    loadingPageData,
    error,
    setError,
    success,
    setSuccess,
    deliveriesCount,
    counters,
    counterLabels,
    deliveryStatusOptions,
    companies,
    generalParamsFetched,
    user,
    isAdmin,
    isAdminStaff,
    isSeller,
    isOperator,
    plan,
    auxSearcher,
    progress,
    loadingObtainTracking,
    handleFilterChange,
    handleDateChange,
    handleChangePage,
    handleChangeRowsPerPage,
    handleOrderFilterChange,
    handleOrderByFilterChange,
    setAuxSearcher,
    getTrackingNumber,
    closeGetTrackingResult,
    changeDriver,
    refetchDeliveries,
    massiveChangeStatus
  } = useDeliveries(props);

  console.log(pageData);

  const [selectedPrintLabels, setSelectedPrintLabels] = useState([]);
  const [snackAlert, setSnackAlert] = useState({ active: false, message: ""}); // , duration: 6000 });
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackAlert({ active: false, message: ""}); // , duration: 6000 });
  };
  const handleSnack = (active, message) => {
    //const duration = typeof message === "string" ? 6000 : null;
    //setSnackAlert({ active, message, duration });
    setSnackAlert({ active, message });
  };

  //define url to call on backend depending on user type
  let user_type_url_path = "api/delivery-resume/";

  let headerTable = [
    { columnName: "check-all", dbName: "label", enabled: true },
    { columnName: "Detalles", dbName: "actions", enabled: true },
    { columnName: "Creado", dbName: "created_at", enabled: true },
    { columnName: "Orden", dbName: "order_id", enabled: true },
    { columnName: "Delivery", dbName: "delivery_id", enabled: true },
    { columnName: "Bultos", dbName: "total_items", enabled: true },
    { columnName: "Estado", dbName: "status", enabled: true },
    { columnName: "Subestado", dbName: "sub_status", enabled: true },
    { columnName: "Referencia", dbName: "reference_id", enabled: true },
    { columnName: "Tracking", dbName: "master_tracking_number", enabled: true },
    { columnName: "Seller", dbName: "seller_name", enabled: true },
    { columnName: "Courier", dbName: "courier", enabled: true },
    { columnName: "Destinatario", dbName: "customer", enabled: true },
    { columnName: "Comuna", dbName: "commune", enabled: true },
    { columnName: "Driver", dbName: "driver", enabled: plan?.plan_type === "admin_checkout" },
    { columnName: "Asignado", dbName: "assigned_at", enabled: plan?.plan_type === "admin_checkout" },
  ];

  if (!generalParamsFetched) {
    return null;
  }

  return (
    <>
      <Grid item xs={12} className="mg-t-20">
        <h2>Mis deliveries</h2>
      </Grid>

      <DeliveryChips
        deliveriesCount={deliveriesCount}
        counters={counters}
        counterLabels={counterLabels}
      />

      <Grid item xs={12} className="mg-t-20 mg-b-20">
        <h4>Acciones</h4>
      </Grid>

      <DeliveryActions
        user={user}
        filters={filters}
        tableSort={tableSort}
        pagination={pagination}
        deliveriesCount={deliveriesCount}
        selectedPrintLabels={selectedPrintLabels}
        pageData={pageData}
        setErrorOnRetrieveData={setError}
        handleSnack={handleSnack}
        onRetryTracking={getTrackingNumber}
        isLoadingTracking={loadingObtainTracking}
        trackingProgress={progress}
        onCloseTrackingResult={closeGetTrackingResult}
        changeDriver={changeDriver}
        isAdmin={isAdmin}
        isAdminStaff={isAdminStaff}
        refetchDeliveries={refetchDeliveries}
        error={error}
        success={success}
        massiveChangeStatus={massiveChangeStatus}
      />

      <DeliveryFilters
        filters={filters}
        auxSearcher={auxSearcher}
        setAuxSearcher={setAuxSearcher}
        handleFilterChange={handleFilterChange}
        handleDateChange={handleDateChange}
        deliveryStatusOptions={deliveryStatusOptions}
        companies={companies}
        user={user}
        daysOffset={props.daysOffset}
        isAdmin={isAdmin}
        plan={plan}
      />

      <Grid container>
        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <>
              {error ? (
                <Alert severity="error">{error}</Alert>
              ) : (
                <CustomTableNew
                  user_type_url_path={user_type_url_path}
                  search={filters.search}
                  filterByDate={
                    filters.startDate !== null && filters.endDate !== null
                  }
                  headerTable={headerTable}
                  selected={"none"}
                  setSelected={"none"}
                  openCollapseButton={true}
                  openCollapseTooltip={"Ver más"}
                  openCollapseIcon={
                    <i className="material-icons-outlined icon-actions-panel-test">
                      add_circle_outline
                    </i>
                  }
                  collapseType={"deliveries-resume"}
                  hasPagination={true}
                  editable={true}
                  filterStates={{
                    startDate: filters.startDate,
                    endDate: filters.endDate,
                    statusFilter: filters.statusFilter,
                    search: filters.search,
                  }}
                  totalCount={deliveriesCount}
                  page={pagination.page}
                  setPage={handleChangePage}
                  rowsPerPage={pagination.rowsPerPage}
                  setRowsPerPage={handleChangeRowsPerPage}
                  pageData={pageData}
                  setPageData={handleChangePage}
                  loadingPageData={loadingPageData}
                  selectedPrintLabels={selectedPrintLabels}
                  setSelectedPrintLabels={setSelectedPrintLabels}
                  setOrderFilter={handleOrderFilterChange}
                  setOrderByFilter={handleOrderByFilterChange}
                  orderFilter={tableSort.orderFilter}
                  orderByFilter={tableSort.orderByFilter}
                  plan={plan}
                />
              )}
            </>
          </Grid>
        </Grid>
      </Grid>
      <Snackbar
        open={snackAlert.active}
        autoHideDuration={6000} //{snackAlert.duration}
        onClose={handleSnackClose}
        message={snackAlert.message}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleSnackClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </>
  );
}

export default DeliveriesResume;
